import React from 'react';
import PaintSingleCategory from '../components/PaintSingleCategory/PaintSingleCategory';

const PaintCategory = () => {
  return (
    <>
      <PaintSingleCategory />
    </>
  );
};

export default PaintCategory;
